import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.states';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-producto',
    templateUrl: './producto.component.html',
    styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {
    selectedProject: string = 'ACME Corp. Backend App';
    data: any = {
        columns: ['Nombre', 'Valor', 'Opciones'],
        rows: []
    };

    idPadre: number = 0;
    curCatalogo: any;
    catalogoForm: FormGroup;
    formModo: number = 1;
    tempEdit: any;

    constructor(
        private readonly store: Store<AppState>,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder
    ) {

    }

    ngOnInit(): void {
        this.setOperacion();
        this.getData();
    }

    setOperacion() {
        let parametros = {}

        this.coalService.postService(`operacion/PostGetOperacion`, parametros)
            .subscribe(
                (res: any) => {
                    if (res.error) {

                    } else if (res.excepcion) {

                    } else {
                        let respuesta = res.recordsets[0][0];
                        respuesta['ajustes'] = res.recordsets[1][0];

                        let data = {
                            idOperacion: respuesta.idOperacion,
                            RFC: respuesta.RFC,
                            razonSocial: respuesta.razonSocial,
                            nombreComercial: respuesta.nombreComercial,
                            contactoEmail: respuesta.contactoEmail,
                            contactoTelefono: respuesta.contactoTelefono,
                            folioInicio: respuesta.folioInicio,
                            fechaConfiguracion: respuesta.fechaConfiguracion,

                            CP: respuesta.CP,
                            calle: respuesta.calle,
                            noExterior: respuesta.noExterior,
                            noInterior: respuesta.noInterior,
                            colonia: respuesta.colonia,

                            estatus: {
                                idOperacionEstatus: respuesta.idOperacionEstatus,
                                nombre: respuesta.nombreEstatus,
                                descripcion: respuesta.descripcionEstatus,
                                fechaRegistro: respuesta.fechaRegistroHistorico
                            },

                            tipoPersona: {
                                idCatalogo: respuesta.idTipoPersona,
                                nombre: respuesta.TipoPersona,
                                valor: respuesta.TipoPersonaValue
                            },

                            giro: {
                                idCatalogo: respuesta.idGiro,
                                nombre: respuesta.Giro,
                                valor: respuesta.GiroValue
                            },

                            regimenFiscal: {
                                idCatalogo: respuesta.idRegimenFiscal,
                                nombre: respuesta.RegimenFiscal,
                                valor: respuesta.RegimenFiscalValue
                            },

                            tamanioEmpresa: {
                                idCatalogo: respuesta.idTamanioEmpresa,
                                nombre: respuesta.TamanioEmpresa,
                                valor: respuesta.TamanioEmpresa
                            },

                            ajustes: {
                                decimal: respuesta.ajustes.decimal,
                                porcentaje: respuesta.ajustes.porcentaje,
                                email_minFolios: respuesta.ajustes.email_minFolios,
                                email_comprobantes: respuesta.ajustes.email_comprobantes
                            }
                        }

                        this.baseService.postOperacionData(data);
                        // this.store.dispatch(AsignarOperacion( respuesta ))
                    }
                }, (error: any) => {

                }
            )
    }

    getData() {
        let parametros = {
            idPadre: 0
        }

        this.coalService.postService(`catalogo/PostGetCatalogos`, parametros)
            .subscribe(
                (res: any) => {
                    if (res.error) {

                    } else if (res.excepcion) {

                    } else {
                        let respuesta = res.recordsets[0];
                        //console.log("respuesta", respuesta);

                        this.data = {
                            columns: ['Nombre', 'Valor', 'Opciones'],
                            rows: respuesta
                        };

                        // this.snackBar.open(respuesta.msg, 'Ok', { duration: 10000 });
                    }
                }, (error: any) => {

                }
            )
    }

    redirect(url: string) {
        this.router.navigateByUrl(url);
        // this.router.navigate(['cuenta']);
    }
}
